/**
 * Calendrier OFFICIEL de la Coupe du Monde FIFA 2026
 * Source : programme officiel FIFA (104 matchs, du 11 juin au 19 juillet 2026)
 *
 * Format : [home_en, away_en, date_fr (DD/MM/YYYY), time (HH:mm), stadium, city, country, group]
 * `group` = 'A'..'L' pour la phase de groupes, null pour les phases finales.
 */

const C = {
  // Phase de groupes (M1 → M72)
  1: ['Mexico', 'South Africa', '11/06/2026', '14:00', 'Estadio Azteca (Estadio Banorte)', 'Ciudad de México', 'Mexique', 'A'],
  2: ['Korea Republic', 'Czech Republic', '11/06/2026', '21:00', 'Estadio Akron (Chivas Stadium)', 'Zapopan', 'Mexique', 'A'],
  3: ['Canada', 'Bosnia and Herzegovina', '12/06/2026', '15:00', 'BMO Field', 'Toronto', 'Canada', 'B'],
  4: ['United States', 'Paraguay', '12/06/2026', '18:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', 'D'],
  5: ['Haiti', 'Scotland', '13/06/2026', '21:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', 'C'],
  6: ['Australia', 'Turkey', '13/06/2026', '21:00', 'BC Place Stadium', 'Vancouver', 'Canada', 'D'],
  7: ['Brazil', 'Morocco', '13/06/2026', '18:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', 'C'],
  8: ['Qatar', 'Switzerland', '13/06/2026', '12:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', 'B'],
  9: ["Côte d'Ivoire", 'Ecuador', '14/06/2026', '19:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', 'E'],
  10: ['Germany', 'Curaçao', '14/06/2026', '12:00', 'NRG Stadium', 'Houston', 'États-Unis', 'E'],
  11: ['Netherlands', 'Japan', '14/06/2026', '15:00', 'AT&T Stadium', 'Arlington', 'États-Unis', 'F'],
  12: ['Sweden', 'Tunisia', '14/06/2026', '21:00', 'Estadio BBVA (Bancomer)', 'Monterrey', 'Mexique', 'F'],
  13: ['Saudi Arabia', 'Uruguay', '15/06/2026', '18:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', 'H'],
  14: ['Spain', 'Cabo Verde', '15/06/2026', '12:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', 'H'],
  15: ['Iran', 'New Zealand', '15/06/2026', '18:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', 'G'],
  16: ['Belgium', 'Egypt', '15/06/2026', '12:00', 'Lumen Field', 'Seattle', 'États-Unis', 'G'],
  17: ['France', 'Senegal', '16/06/2026', '15:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', 'I'],
  18: ['Iraq', 'Norway', '16/06/2026', '18:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', 'I'],
  19: ['Argentina', 'Algeria', '16/06/2026', '20:00', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', 'J'],
  20: ['Austria', 'Jordan', '16/06/2026', '21:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', 'J'],
  21: ['Ghana', 'Panama', '17/06/2026', '19:00', 'BMO Field', 'Toronto', 'Canada', 'L'],
  22: ['England', 'Croatia', '17/06/2026', '15:00', 'AT&T Stadium', 'Arlington', 'États-Unis', 'L'],
  23: ['Portugal', 'DR Congo', '17/06/2026', '12:00', 'NRG Stadium', 'Houston', 'États-Unis', 'K'],
  24: ['Uzbekistan', 'Colombia', '17/06/2026', '21:00', 'Estadio Azteca (Estadio Banorte)', 'Ciudad de México', 'Mexique', 'K'],
  25: ['Czech Republic', 'South Africa', '18/06/2026', '12:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', 'A'],
  26: ['Switzerland', 'Bosnia and Herzegovina', '18/06/2026', '12:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', 'B'],
  27: ['Canada', 'Qatar', '18/06/2026', '15:00', 'BC Place Stadium', 'Vancouver', 'Canada', 'B'],
  28: ['Mexico', 'Korea Republic', '18/06/2026', '20:00', 'Estadio Akron (Chivas Stadium)', 'Zapopan', 'Mexique', 'A'],
  29: ['Brazil', 'Haiti', '19/06/2026', '21:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', 'C'],
  30: ['Scotland', 'Morocco', '19/06/2026', '18:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', 'C'],
  31: ['Turkey', 'Paraguay', '19/06/2026', '21:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', 'D'],
  32: ['United States', 'Australia', '19/06/2026', '12:00', 'Lumen Field', 'Seattle', 'États-Unis', 'D'],
  33: ['Germany', "Côte d'Ivoire", '20/06/2026', '16:00', 'BMO Field', 'Toronto', 'Canada', 'E'],
  34: ['Ecuador', 'Curaçao', '20/06/2026', '19:00', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', 'E'],
  // M35: non listé dans les données fournies — laissé pour future complétion
  36: ['Tunisia', 'Japan', '20/06/2026', '22:00', 'Estadio BBVA (Bancomer)', 'Monterrey', 'Mexique', 'F'],
  37: ['Uruguay', 'Cabo Verde', '21/06/2026', '18:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', 'H'],
  38: ['Spain', 'Saudi Arabia', '21/06/2026', '12:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', 'H'],
  39: ['Belgium', 'Iran', '21/06/2026', '12:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', 'G'],
  40: ['New Zealand', 'Egypt', '21/06/2026', '18:00', 'BC Place Stadium', 'Vancouver', 'Canada', 'G'],
  41: ['Norway', 'Senegal', '22/06/2026', '20:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', 'I'],
  42: ['France', 'Iraq', '22/06/2026', '17:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', 'I'],
  43: ['Argentina', 'Austria', '22/06/2026', '12:00', 'AT&T Stadium', 'Arlington', 'États-Unis', 'J'],
  44: ['Jordan', 'Algeria', '22/06/2026', '20:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', 'J'],
  45: ['England', 'Ghana', '23/06/2026', '16:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', 'L'],
  46: ['Panama', 'Croatia', '23/06/2026', '19:00', 'BMO Field', 'Toronto', 'Canada', 'L'],
  47: ['Portugal', 'Uzbekistan', '23/06/2026', '12:00', 'NRG Stadium', 'Houston', 'États-Unis', 'K'],
  48: ['Colombia', 'DR Congo', '23/06/2026', '21:00', 'Estadio Akron (Chivas Stadium)', 'Zapopan', 'Mexique', 'K'],
  49: ['Scotland', 'Brazil', '24/06/2026', '18:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', 'C'],
  50: ['Morocco', 'Haiti', '24/06/2026', '18:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', 'C'],
  51: ['Switzerland', 'Canada', '24/06/2026', '12:00', 'BC Place Stadium', 'Vancouver', 'Canada', 'B'],
  52: ['Bosnia and Herzegovina', 'Qatar', '24/06/2026', '12:00', 'Lumen Field', 'Seattle', 'États-Unis', 'B'],
  53: ['Czech Republic', 'Mexico', '24/06/2026', '20:00', 'Estadio Azteca (Estadio Banorte)', 'Ciudad de México', 'Mexique', 'A'],
  54: ['South Africa', 'Korea Republic', '24/06/2026', '20:00', 'Estadio BBVA (Bancomer)', 'Monterrey', 'Mexique', 'A'],
  55: ['Curaçao', "Côte d'Ivoire", '25/06/2026', '16:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', 'E'],
  56: ['Ecuador', 'Germany', '25/06/2026', '16:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', 'E'],
  57: ['Japan', 'Sweden', '25/06/2026', '18:00', 'AT&T Stadium', 'Arlington', 'États-Unis', 'F'],
  58: ['Tunisia', 'Netherlands', '25/06/2026', '18:00', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', 'F'],
  59: ['Turkey', 'United States', '25/06/2026', '19:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', 'D'],
  60: ['Paraguay', 'Australia', '25/06/2026', '19:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', 'D'],
  61: ['Norway', 'France', '26/06/2026', '15:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', 'I'],
  62: ['Senegal', 'Iraq', '26/06/2026', '15:00', 'BMO Field', 'Toronto', 'Canada', 'I'],
  63: ['Egypt', 'Iran', '26/06/2026', '20:00', 'Lumen Field', 'Seattle', 'États-Unis', 'G'],
  64: ['New Zealand', 'Belgium', '26/06/2026', '20:00', 'BC Place Stadium', 'Vancouver', 'Canada', 'G'],
  65: ['Cabo Verde', 'Saudi Arabia', '26/06/2026', '19:00', 'NRG Stadium', 'Houston', 'États-Unis', 'H'],
  66: ['Uruguay', 'Spain', '26/06/2026', '19:00', 'Estadio Akron (Chivas Stadium)', 'Zapopan', 'Mexique', 'H'],
  67: ['Panama', 'England', '27/06/2026', '17:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', 'L'],
  68: ['Croatia', 'Ghana', '27/06/2026', '17:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', 'L'],
  69: ['Algeria', 'Austria', '27/06/2026', '21:00', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', 'J'],
  70: ['Jordan', 'Argentina', '27/06/2026', '21:00', 'AT&T Stadium', 'Arlington', 'États-Unis', 'J'],
  71: ['Colombia', 'Portugal', '27/06/2026', '19:30', 'Hard Rock Stadium', 'Miami', 'États-Unis', 'K'],
  72: ['DR Congo', 'Uzbekistan', '27/06/2026', '19:30', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', 'K'],
  // 1/16 de finale (Round of 32) — équipes désignées par codes, pas de groupe
  73: ['2A', '2B', '28/06/2026', '12:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', null],
  74: ['1E', '3A/B/C/D/F', '29/06/2026', '16:30', 'Gillette Stadium', 'Foxborough', 'États-Unis', null],
  75: ['1F', '2C', '29/06/2026', '20:00', 'Estadio BBVA (Bancomer)', 'Monterrey', 'Mexique', null],
  76: ['1C', '2F', '29/06/2026', '12:00', 'NRG Stadium', 'Houston', 'États-Unis', null],
  77: ['1I', '3C/D/F/G/H', '30/06/2026', '17:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', null],
  78: ['2E', '2I', '30/06/2026', '12:00', 'AT&T Stadium', 'Arlington', 'États-Unis', null],
  79: ['1A', '3C/E/F/H/I', '30/06/2026', '20:00', 'Estadio Azteca (Estadio Banorte)', 'Ciudad de México', 'Mexique', null],
  80: ['1L', '3E/H/I/J/K', '01/07/2026', '12:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', null],
  81: ['1D', '3B/E/F/I/J', '01/07/2026', '17:00', "Levi's Stadium", 'Santa Clara', 'États-Unis', null],
  82: ['1G', '3A/E/H/I/J', '01/07/2026', '13:00', 'Lumen Field', 'Seattle', 'États-Unis', null],
  83: ['2K', '2L', '02/07/2026', '19:00', 'BMO Field', 'Toronto', 'Canada', null],
  84: ['1H', '2J', '02/07/2026', '12:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', null],
  85: ['1B', '3E/F/G/I/J', '02/07/2026', '20:00', 'BC Place Stadium', 'Vancouver', 'Canada', null],
  86: ['1J', '2H', '03/07/2026', '18:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', null],
  87: ['1K', '3D/E/I/J/L', '03/07/2026', '20:30', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', null],
  88: ['2D', '2G', '03/07/2026', '13:00', 'AT&T Stadium', 'Arlington', 'États-Unis', null],
  // 1/8 de finale
  89: ['W74', 'W77', '04/07/2026', '17:00', 'Lincoln Financial Field', 'Philadelphie', 'États-Unis', null],
  90: ['W73', 'W75', '04/07/2026', '12:00', 'NRG Stadium', 'Houston', 'États-Unis', null],
  91: ['W76', 'W78', '05/07/2026', '16:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', null],
  92: ['W79', 'W80', '05/07/2026', '19:00', 'Estadio Azteca (Estadio Banorte)', 'Ciudad de México', 'Mexique', null],
  93: ['W83', 'W84', '06/07/2026', '14:00', 'AT&T Stadium', 'Arlington', 'États-Unis', null],
  94: ['W81', 'W82', '06/07/2026', '17:00', 'Lumen Field', 'Seattle', 'États-Unis', null],
  95: ['W86', 'W88', '07/07/2026', '12:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', null],
  96: ['W85', 'W87', '07/07/2026', '13:00', 'BC Place Stadium', 'Vancouver', 'Canada', null],
  // Quarts de finale
  97: ['W89', 'W90', '09/07/2026', '16:00', 'Gillette Stadium', 'Foxborough', 'États-Unis', null],
  98: ['W93', 'W94', '10/07/2026', '12:00', 'SoFi Stadium', 'Inglewood', 'États-Unis', null],
  99: ['W91', 'W92', '11/07/2026', '17:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', null],
  100: ['W95', 'W96', '11/07/2026', '20:00', 'GEHA Field at Arrowhead Stadium', 'Kansas City', 'États-Unis', null],
  // Demi-finales
  101: ['W97', 'W98', '14/07/2026', '14:00', 'AT&T Stadium', 'Arlington', 'États-Unis', null],
  102: ['W99', 'W100', '15/07/2026', '15:00', 'Mercedes-Benz Stadium', 'Atlanta', 'États-Unis', null],
  // 3e place
  103: ['L101', 'L102', '18/07/2026', '17:00', 'Hard Rock Stadium', 'Miami', 'États-Unis', null],
  // Finale
  104: ['W101', 'W102', '19/07/2026', '15:00', 'MetLife Stadium', 'East Rutherford', 'États-Unis', null],
};

export const WC_2026_CALENDAR = C;

export const getOfficialMatch = (matchNum) => {
  if (!matchNum) return null;
  const data = C[matchNum];
  if (!data) return null;
  return {
    matchNum,
    home: data[0],
    away: data[1],
    date: data[2],    // 'DD/MM/YYYY'
    time: data[3],    // 'HH:mm'
    stadium: data[4],
    city: data[5],
    country: data[6],
    group: data[7],   // 'A'..'L' ou null
  };
};

export const getMatchPhase = (matchNum, lang = 'fr') => {
  if (!matchNum) return null;
  const phases = {
    fr: {
      groups: 'Phase de groupes', r32: '1/16 de finale', r16: '1/8 de finale',
      qf: 'Quarts de finale', sf: 'Demi-finales', third: '3e place', final: 'Finale',
    },
    en: {
      groups: 'Group Stage', r32: 'Round of 32', r16: 'Round of 16',
      qf: 'Quarter-finals', sf: 'Semi-finals', third: '3rd place', final: 'Final',
    },
  };
  const P = phases[lang] || phases.fr;
  if (matchNum <= 72) return P.groups;
  if (matchNum <= 88) return P.r32;
  if (matchNum <= 96) return P.r16;
  if (matchNum <= 100) return P.qf;
  if (matchNum <= 102) return P.sf;
  if (matchNum === 103) return P.third;
  if (matchNum === 104) return P.final;
  return null;
};


// =====================================================
// Conversion heure locale → heure de Paris (Europe/Paris)
// =====================================================
// Pour chaque ville hôte de la WC 2026, on définit son fuseau IANA. Le navigateur
// fait la conversion automatiquement (gère heure d'été des US/Canada/Mexique/Paris).
//
// Si tu veux RETIRER cette feature : supprime simplement les appels à
// `getMatchTimeFR()` dans les composants — aucune autre dépendance.

const CITY_TIMEZONES = {
  // États-Unis
  'Inglewood': 'America/Los_Angeles',
  'Santa Clara': 'America/Los_Angeles',
  'Seattle': 'America/Los_Angeles',
  'Houston': 'America/Chicago',
  'Arlington': 'America/Chicago',
  'Kansas City': 'America/Chicago',
  'Atlanta': 'America/New_York',
  'East Rutherford': 'America/New_York',
  'Foxborough': 'America/New_York',
  'Miami': 'America/New_York',
  'Philadelphie': 'America/New_York',
  // Canada
  'Toronto': 'America/Toronto',
  'Vancouver': 'America/Vancouver',
  // Mexique
  'Ciudad de México': 'America/Mexico_City',
  'Monterrey': 'America/Monterrey',
  'Zapopan': 'America/Mexico_City', // Guadalajara metro
};

/**
 * Renvoie l'heure de Paris pour un match donné, sous forme d'objet :
 *   {
 *     time: 'HH:mm',                       // heure de Paris (coup d'envoi)
 *     dayShift: -1|0|+1,                   // décalage de jour vs date locale du match
 *     label: 'HH:mm' ou 'HH:mm (12/06)',   // libellé prêt à afficher
 *     startUTC: millis,                    // timestamp UTC du coup d'envoi (utile pour comparer à Date.now())
 *     listingClosesLabel: 'HH:mm'          // heure FR à laquelle le listing Viagogo ferme (= coup d'envoi - 4h)
 *   }
 * - Retourne `null` si le match n'est pas dans le calendrier officiel ou que la ville n'est pas mappée.
 */
export const getMatchTimeFR = (matchNum) => {
  const m = getOfficialMatch(matchNum);
  if (!m || !m.date || !m.time || !m.city) return null;
  const tz = CITY_TIMEZONES[m.city];
  if (!tz) return null;
  try {
    // Parse 'DD/MM/YYYY' + 'HH:mm' comme heure LOCALE (du fuseau du stade)
    const [dd, mm, yyyy] = m.date.split('/').map(Number);
    const [hh, mi] = m.time.split(':').map(Number);
    // On construit un Date dans le fuseau local du stade en passant par une astuce :
    // créer un Date UTC à l'heure prétendue, puis ajuster avec l'offset du fuseau.
    const pretendUTC = Date.UTC(yyyy, mm - 1, dd, hh, mi);
    // Offset du fuseau du stade à cette date (en ms)
    const stadiumOffset = getTzOffsetMs(tz, new Date(pretendUTC));
    const realUTC = pretendUTC - stadiumOffset;
    let realDate = new Date(realUTC);
    // Correction métier (per user) : retirer 1 h pour les villes du Mexique
    // (le calcul mathématique IANA donne 8h d'écart Mexico↔Paris en juin, mais
    // l'utilisateur indique que les heures réelles sont à -1h).
    if (m.country === 'Mexique') {
      realDate = new Date(realDate.getTime() - 60 * 60 * 1000);
    }
    // Conversion vers Paris
    const parisOffset = getTzOffsetMs('Europe/Paris', realDate);
    const parisLocal = new Date(realDate.getTime() + parisOffset);
    const phh = String(parisLocal.getUTCHours()).padStart(2, '0');
    const pmi = String(parisLocal.getUTCMinutes()).padStart(2, '0');
    const pdd = parisLocal.getUTCDate();
    const pmm = parisLocal.getUTCMonth() + 1;
    // Décalage de jour vs date locale du match
    const dayShift = pdd - dd + (pmm !== mm ? (pmm > mm ? 31 : -31) : 0);
    let label = `${phh}:${pmi}`;
    if (dayShift !== 0) {
      label = `${phh}:${pmi} (${String(pdd).padStart(2, '0')}/${String(pmm).padStart(2, '0')})`;
    }
    // Timestamp UTC réel du coup d'envoi (pour comparer à Date.now())
    const startUTC = realDate.getTime();
    // Listing Viagogo ferme 4h avant le coup d'envoi → on calcule l'heure FR correspondante
    const listingDate = new Date(realDate.getTime() - 4 * 60 * 60 * 1000);
    const listingParisLocal = new Date(listingDate.getTime() + getTzOffsetMs('Europe/Paris', listingDate));
    const lhh = String(listingParisLocal.getUTCHours()).padStart(2, '0');
    const lmi = String(listingParisLocal.getUTCMinutes()).padStart(2, '0');
    const ldd = listingParisLocal.getUTCDate();
    const lmm = listingParisLocal.getUTCMonth() + 1;
    const listingDayShift = ldd - dd + (lmm !== mm ? (lmm > mm ? 31 : -31) : 0);
    let listingClosesLabel = `${lhh}:${lmi}`;
    if (listingDayShift !== 0) {
      listingClosesLabel = `${lhh}:${lmi} (${String(ldd).padStart(2, '0')}/${String(lmm).padStart(2, '0')})`;
    }
    return { time: `${phh}:${pmi}`, dayShift, label, startUTC, listingClosesLabel };
  } catch {
    return null;
  }
};

// Calcule l'offset (en ms) d'un fuseau IANA pour une date donnée.
// On compare la même date formatée en UTC vs formatée dans le fuseau cible.
function getTzOffsetMs(tz, date) {
  try {
    const fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
    });
    const parts = fmt.formatToParts(date).reduce((acc, p) => {
      if (p.type !== 'literal') acc[p.type] = p.value;
      return acc;
    }, {});
    const asUTC = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour) % 24, // 'en-US' peut renvoyer 24:00 — on ramène à 0
      Number(parts.minute),
      Number(parts.second),
    );
    return asUTC - date.getTime();
  } catch {
    return 0;
  }
}
